export interface INcsScore {
    goodSamaritanNdd: number,
    goodSamaritanFvd: number,
    waitListChainEndTransplants: number,
    kidneyReplacementCaseTransplants: number,
    familyVoucherRedemptionTransplants: number,
    pendingWaitListChainEndTransplants: number,
    actualNcsScore: number,
    forecastedNcsScore: number,
}